import React from 'react';
import { Container, Header, Button, Segment } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const FileView = (props) => {
  const { content } = props;

  const downloadUrl = flattenToAppURL(content.file?.download);
  const contentType = content.file?.['content-type'];
  const isPdf = contentType === 'application/pdf';
  const filename = content.title || 'file';

  const getDisplayUrl = (url) => {
    // Get the content path
    const contentPath = url.split('/@@')[0];
    // Use our custom display-pdf view
    return contentPath + '/@@display-pdf';
  };

  const displayUrl = getDisplayUrl(flattenToAppURL(content['@id']));

  const renderFileContent = () => {
    if (isPdf) {
      return (
        <div className="file-actions">
          <Button
            primary
            as="a"
            href={displayUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View PDF
          </Button>
          <Button
            as="a"
            href={downloadUrl}
            download={`${filename}.pdf`}
            style={{ marginLeft: '10px' }}
          >
            Download PDF
          </Button>
        </div>
      );
    } else {
      return (
        <Button primary as="a" href={downloadUrl} download={filename}>
          Download {filename}
        </Button>
      );
    }
  };

  return (
    <Container id="view-wrapper file-view">
      <h1 className="documentFirstHeading">{content.title}</h1>
      {content.description && (
        <p className="documentDescription">{content.description}</p>
      )}
      <Segment>
        <Header as="h2">File Content</Header>
        {renderFileContent()}
      </Segment>
      <Segment>
        <Header as="h3">File Details</Header>
        <p>File Type: {contentType}</p>
        <p>File Size: {content.file?.size} bytes</p>
      </Segment>
    </Container>
  );
};

export default FileView;
